import { useAppSelector } from 'shared';

export const useSweetShopPageState = () => useAppSelector((store) => store.sweetShopPage);
